import {CSSProperties, FC} from 'react';


export interface IIconTransmissionMBmwProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconTransmissionMBmw: FC<IIconTransmissionMBmwProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M12 3c2.404 0 4.664.936 6.364 2.636A8.941 8.941 0 0 1 21 12a8.941 8.941 0 0 1-2.636 6.364A8.941 8.941 0 0 1 12 21a8.941 8.941 0 0 1-6.364-2.636A8.941 8.941 0 0 1 3 12c0-2.404.936-4.664 2.636-6.364A8.941 8.941 0 0 1 12 3Zm-.587 13.367h1.174v-3.78h4.262V7.633h-1.173v3.78h-3.089v-3.78h-1.174v3.78H8.324v-3.78H7.151v8.734h1.173v-3.78h3.09v3.78ZM15 13.5v3.016h.613v-2.149l.715 2.149h.533l.711-2.149v2.149h.617V13.5h-.853l-.727 2.24-.736-2.24H15Z" clipRule="evenodd" />
        </svg>
    );
};
